module.exports = __webpack_public_path__ + "img/video.e0f8b3c7.png";